<template>
  <div class="search-switcher">
    <div @click="toggleSearch" class="search-switcher__search">
      <button class="search-switcher__button search-switcher__button-search" type="button">
        SZUKAJ
        <Icon icon="v" />
      </button>
    </div>

    <div @click="toggleFilters" class="search-switcher__filter">
      <button class="search-switcher__button search-switcher__button-filter" type="button">
        Filtruj
        <Icon icon="v" />
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
  },
})
export default class FilterSwitcher extends Vue {
  toggleSearch () {
    this.$emit('toggleSearch')
  }

  toggleFilters () {
    this.$emit('toggleFilters')
  }
}
</script>

<style lang="scss">
.search-switcher {
  display: flex;
  width: 100vw;

  &__search {
    flex: 1 0 auto;
    line-height: 36px;
    background-color: #005CA9;
    padding-left: 14px;
  }

  &__filter {
    width: 120px;
    line-height: 36px;
    background-color: #009FEA;
    text-align: center;
    padding-left: 14px;
  }

  &__button {
    background-color: transparent;
    border: 0;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    font-family: 'Gotham';
    line-height: normal;
    text-transform: uppercase;
    display: flex;
    height: 35px;
    align-items: center;

    .figure {
      font-size: 6px;
      &::before {
        vertical-align: middle;
        padding-bottom: 7px;
        padding-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/FilterSwitcher.vue